'use client'

import { ReactNode } from 'react'
import { usePathname } from 'next/navigation'

import AllProviders from '@/providers'
import ContentLayout from '@/components/common/layout/ContentLayout'
import SetHtmlLang from '@/components/common/SetHtmlLang'
import { defaultLocale, getLocaleFromPath } from '@/utils/locale'

interface RootLayoutContentProps {
  children: ReactNode
  menuData: any
}

export default function RootLayoutContent({ children, menuData }: RootLayoutContentProps) {
  const pathname = usePathname()
  const locale = getLocaleFromPath(pathname) || defaultLocale

  return (
    <AllProviders locale={locale}>
      <SetHtmlLang lang={locale} />
      <ContentLayout menuData={menuData}>{children}</ContentLayout>
    </AllProviders>
  )
}
